import { useEffect } from "react";

export const AdSenseInline = () => {
  useEffect(() => {
    // Load the Google AdSense script
    const script = document.createElement("script");
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8363100582939284";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    // Initialize adsbygoogle once the script is loaded
    script.onload = () => {
      // @ts-expect-error
      // biome-ignore lint/suspicious/noAssignInExpressions: Ads
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    };
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-format="fluid"
      data-ad-layout-key="-fb+5w+4e-db+86"
      data-ad-client="ca-pub-8363100582939284"
      data-ad-slot="2292211446"
    />
  );
};
